import { useState, useEffect, useContext } from "react";
import { getCars } from "../../api/cars.api";
import InputChecklist from "./InputChecklist";
import OverlayLoading from "./OverlayLoading";
import styles from "./NewChecklist.module.css";
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../../components/ui/select";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { createChecklist } from "../../api/checklists.api";
import { createTicket } from "../../api/tickets.api";
import { useNavigate } from "react-router-dom";
import { check } from "../../api/users.api";
import { UserContext } from "../../context/UserContext";
import { use } from "react";

function NewChecklist() {

    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [carId, setCarId] = useState("");
    const [cars, setCars] = useState([]);
    const [observacao, setObservacao] = useState("");
    const [quilometragem, setQuilometragem] = useState(0) 
    const [openTickets, setOpenTickets] = useState([]);

    const initialChecklist = [
        { key: "freioDePe", item: "Freio de pé", problema: false, descricao: "" },
        { key: "freioDeEstacionamento", item: "Freio de estacionamento", problema: false, descricao: "" },
        { key: "motorDePartida", item: "Motor de partida", problema: false, descricao: "" },
        { key: "limpadorDeParabrisa", item: "Limpador de parabrisa", problema: false, descricao: "" },
        { key: "lavadorDeParabrisa", item: "Lavador de parabrisa", problema: false, descricao: "" },
        { key: "buzina", item: "Buzina", problema: false, descricao: "" },
        { key: "farois", item: "Faróis", problema: false, descricao: "" },
        { key: "lanternasDianteiras", item: "Lanternas dianteiras (seta)", problema: false, descricao: "" },
        { key: "lanternasTraseiras", item: "Lanternas traseiras (seta)", problema: false, descricao: "" },
        { key: "luzDeRe", item: "Luz de ré", problema: false, descricao: "" },
        { key: "luzDaPlaca", item: "Luz da placa", problema: false, descricao: "" },
        { key: "indicadoresDePainel", item: "Indicadores de painel", problema: false, descricao: "" },
        { key: "cintoDeSeguranca", item: "Cinto de segurança", problema: false, descricao: "" },
        { key: "luzDeFreio", item: "Luz de freio", problema: false, descricao: "" },
        { key: "fechamentoDeJanelas", item: "Fechamento de janelas", problema: false, descricao: "" },
        { key: "trianguloDeAdvertencia", item: "Triângulo de advertência", problema: false, descricao: "" },
        { key: "macaco", item: "Macaco", problema: false, descricao: "" },
        { key: "chaveDeRoda", item: "Chave de roda", problema: false, descricao: "" },
        { key: "condicaoDosPneus", item: "Condição dos pneus", problema: false, descricao: "" },
        { key: "pneuEstepe", item: "Pneu estepe", problema: false, descricao: "" },
        { key: "vidros", item: "Vidros", problema: false, descricao: "" },
        { key: "portas", item: "Portas", problema: false, descricao: "" },
        { key: "paraChoqueDianteiro", item: "Para-choque dianteiro", problema: false, descricao: "" },
        { key: "paraChoqueTraseiro", item: "Para-choque traseiro", problema: false, descricao: "" },
        { key: "lataria", item: "Lataria", problema: false, descricao: "" },
        { key: "espelhosRetrovisores", item: "Espelhos retrovisores", problema: false, descricao: "" },
        { key: "nivelDeOleo", item: "Nível de óleo", problema: false, descricao: "" },
        { key: "nivelFluidoDeFreio", item: "Nível fluido de freio", problema: false, descricao: "" },
        { key: "nivelDeAgua", item: "Nível de água", problema: false, descricao: "" },
        { key: "documentacaoDoCarro", item: "Documentação do carro", problema: false, descricao: "" },
        { key: "possuiVazamentos", item: "O veículo possui vazamentos", problema: false, descricao: "" }
    ];

    const [checklist, setChecklist] = useState(initialChecklist);

    const selectedCar = cars.find(c => c.id.toString() === carId);

    const { userId } = useContext(UserContext);

    console.log(observacao)

    useEffect(() => {
        check()
            .then(() => getCars().then(res => setCars(res.data)))
            .catch(() => navigate("/login"));
    }, []);

    useEffect(() => {
        if (!selectedCar || !selectedCar.tickets) return;

        const ticketsEmAberto = selectedCar.tickets.filter(
            ticket => ticket.status != "Finalizado"
        );



        setChecklist(prev => {
            const updated = [...prev];

            ticketsEmAberto.forEach((ticket) => {
                const index = updated.findIndex(
                    item => item.item === ticket.pontoDeVerificacao
                );



                updated[index] = {
                    ...updated[index],
                    problema: true,
                    descricao: ticket.descricao
                };
            });

            return updated;
        });

    }, [selectedCar])

    const updateValue = (key, newValue) => {
        setChecklist(prev =>
            prev.map(item =>
                item.key === key ? { ...item, problema: newValue } : item
            )
        );
    };

    const updateDescricao = (key, descricao) => {
        setChecklist(prev =>
            prev.map(item =>
                item.key === key ? { ...item, descricao } : item
            )
        );
    };

    const handleSubmit = async () => {

        const itensInvalidos = checklist.filter(
            item => item.problema === true && !item.descricao.trim()
        );

        if (itensInvalidos.length > 0) {
            toast.error("Descreva o problema dos itens marcados como erro.");
            return;
        }

        const payload = {
            CarId: Number(carId),
            Observacao: observacao,
            Quilometragem: quilometragem,
            UserId: userId,
            TecnicoId: selectedCar?.tecnico?.id,
            Aprovado: !checklist.some(item => item.problema === true),
            Itens: checklist.map(item => ({
                Item: item.item,
                Problema: item.problema,
                Descricao: item.problema === true ? item.descricao?.trim() : null
            }))
        };

        createChecklist(payload)
            .then((res) => {
                const itensInvalidos = res.data.itens.filter(
                    item => item.problema === true
                );

                if (itensInvalidos.length > 0) {
                    toast.info("Checklist criado, iniciando criação dos Tickets")
                    setIsOpen(true)
                    setTimeout(() => {
                        navigate("/checklists")
                    }, 2000);
                } else {
                    toast.success("Checklist criado!")
                    navigate("/checklists")
                }
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    toast.error("Usuário não autenticado")
                    navigate("/login")
                } else {
                    toast.error("Não foi possível criar checklist")
                    navigate("/checklists")
                }
            })

    };

    return (
        <main className={styles.container}>
            <form className={styles.form} onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}>
                <h1>Novo Checklist</h1>

                <div className={styles.infos}>
                    <div className={styles.select}>
                        <label>Carro</label>
                        <SelectRoot value={carId} onValueChange={setCarId}>
                            <SelectTrigger />
                            <SelectContent>
                                {Array.isArray(cars) ? cars.map((carro) => {
                                    return <SelectItem value={`${carro.id}`} key={carro.id}>{carro.placa}</SelectItem>
                                }) : ""}
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.infoCar}>
                        <div className={styles.containerInput}>
                            <label>Condutor</label>
                            <input type="text" value={selectedCar?.tecnico?.name} readOnly className={styles.inputPassword} />
                        </div>
                        <div className={styles.containerInput}>
                            <label>Setor</label>
                            <input type="text" value={selectedCar?.tecnico?.setor} readOnly className={styles.inputPassword} />
                        </div>
                    </div>
                    <div className={styles.select}>
                        <label>Quilometragem</label>
                        <input type="number" className={styles.inputPassword} onChange={(e) => setQuilometragem(e.target.value)}/>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <td>
                                <span>Descrição</span>
                            </td>
                            <td>
                                <span>Ok</span>
                            </td>
                            <td>
                                <span>Erro</span>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {checklist.map(item => (
                            <InputChecklist
                                key={item.key}
                                itemKey={item.key}
                                item={item}
                                onChangeValue={updateValue}
                                onChangeDescricao={updateDescricao}
                            />
                        ))}
                    </tbody>
                </table>
                <div className={styles.containerInput}>
                    <label>Observação:</label>
                    <textarea type="text" className={styles.textarea} onChange={(e) => setObservacao(e.target.value)}/>
                </div>

                <button className={styles.btn} type="submit">
                    Finalizar Checklist
                </button>

                <button
                    className={styles.cancel}
                    type="button"
                    onClick={() => navigate("/checklists")}
                >
                    Cancelar
                </button>
            </form>

            {isOpen && <OverlayLoading />}
        </main>
    );
}

export default NewChecklist;